import moment from 'moment';
import { checkCircleSVG, errorCircleSVG } from '../../shared/helpers/icons';

export const buildSimcards = (simcards) => simcards.map((simcard => buildSimcard(simcard)))

export const buildSimcard = (simcard) => ({
    ...simcard,
    activation_date: moment(simcard.activation_date).format("DD-MM-YYYY"),
    activation_completeDate: simcard.activation_date,
    enabledIcon: simcard.enabled ? checkCircleSVG : errorCircleSVG,
    iccid: simcard.iccid.toString().toUpperCase(),
    number: simcard.number.toString().toUpperCase(),
});